module.exports = __webpack_public_path__ + "static/media/show-project-button.d02dfc55.svg";